import React from 'react';
import { paginationProps } from './interface';
import { Pagination, ConfigProvider } from '@firesoon/antd';
import zhCN from '@firesoon/antd/es/locale/zh_CN';

import './index.less';

const Index = (props: paginationProps) => {
  const { total = 0, localezhCN = false, ...rest } = props;

  return localezhCN ? (
    <ConfigProvider locale={zhCN}>
      <Pagination size="small" total={total} showTotal={(total, range) => `共 ${total} 条`} {...rest} />
    </ConfigProvider>
  ) : (
    <Pagination size="small" total={total} showTotal={(total, range) => `共 ${total} 条`} {...rest} />
  );
};

export default Index;
